"use client";

import { handleCheckoutSession } from "@/app/utils/checkout-session";
import { handleScroll } from "@/app/utils/scroll";
import { DISCOUNT_ID, PRICING_ID_T1, PRICING_NAME_T1 } from "@/lib/constants";
import Image from "next/image";

export default function About() {
  return (
    <div
      id="about"
      className={`bg-ink flex flex-col justify-center items-center w-full py-24 px-6`}
    >
      {/* Section badge */}
      <div className="w-full xl:w-[1250px] mx-auto text-center pb-6">
        <div
          className={`mb-6 inline-flex items-center gap-2 rounded-full border border-line bg-panel/70 px-4 py-1.5 text-sm font-medium text-zinc-300 shadow-sm backdrop-blur`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-primary"
          >
            <path d="M18 20a6 6 0 0 0-12 0" />
            <circle cx="12" cy="10" r="4" />
            <circle cx="12" cy="12" r="10" />
          </svg>
          About
        </div>
      </div>

      {/* Card with decorative blobs */}
      <div className="relative w-full xl:w-[1250px] w-full">
        {/* Brand glow */}
        <div className="absolute -inset-10 -z-10 pointer-events-none">
          <div className="absolute left-1/2 top-1/2 h-80 w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(11,99,222,0.14),transparent_70%)] blur-2xl" />
        </div>

        <div className="card bg-panel w-full lg:p-8 shadow-2xl shadow-black/30 border border-line rounded-2xl overflow-hidden relative">
          {/* Gradient top accent */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#4d94ff] via-primary to-[#0a4fb0]" />

          <div className="pt-2">
            {/* Profile section */}
            <div className="card-body flex flex-col justify-center items-center">
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-br from-[#4d94ff] to-[#0a4fb0] rounded-full opacity-75 blur-sm" />
                <Image
                  className="w-36 rounded-full ring-4 ring-panel relative"
                  src={"/images/general/pfp.webp"}
                  width={500}
                  height={500}
                  alt={"The creator of ExtensionFast"}
                />
              </div>
              <h3 className="card-title text-2xl text-white pt-3 text-center">
                Hey, it&apos;s Michael
              </h3>
            </div>

            {/* Story content */}
            <div className="flex flex-col gap-y-6 text-zinc-300 text-lg items-baseline max-w-2xl mx-auto">
              <p className="font-bold text-xl text-white border-l-4 border-primary pl-4">
                I&apos;ve shipped multiple Chrome extensions from scratch.
              </p>
              <p className="text-zinc-400">
                Along the way, I wasted weeks on the same problems every time.
                Wiring up payments, fighting Google OAuth, getting rejected by
                the Chrome Web Store.
              </p>
              <p className="font-bold text-xl text-white border-l-4 border-primary pl-4">
                So I built the starter kit I wish I had.
              </p>
              <p className="text-zinc-400">
                ExtensionFast gives you everything you need to go from idea to a
                published, monetized extension. No need to repeat my mistakes.
              </p>
              <p className="text-zinc-400">
                If you&apos;ve been sitting on an extension idea,{" "}
                <button
                  onClick={() => handleScroll("cta")}
                  className="font-bold text-primary cursor-pointer hover:underline"
                >
                  ExtensionFast
                </button>{" "}
                is your shortcut to getting it live and earning.
              </p>
            </div>

            {/* CTA */}
            <div className="flex flex-col justify-center items-center pt-8 pb-10">
              <div className="w-full max-w-2xl mx-auto mb-8 h-px bg-gradient-to-r from-transparent via-line to-transparent" />
              <button
                className={`btn btn-ghost text-white bg-primary hover:bg-secondary px-8 py-3 rounded-full ring-1 ring-inset ring-white/15 text-base font-semibold transition-all duration-200 shadow-[0_10px_36px_-10px_rgba(11,99,222,0.6)] active:scale-[0.98]`}
                onClick={() =>
                  handleCheckoutSession(
                    PRICING_ID_T1,
                    DISCOUNT_ID,
                    PRICING_NAME_T1,
                    "about",
                  )
                }
              >
                Start Building Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
